import type {
  CabinetDetails,
  CreateCabinetFromCatalogRequest,
  CreateCabinetRequest,
  ListCabinetsResponse,
  UpdateCabinetRequest,
} from '@kreart/shared';
import { api } from '@/lib/api';

export const cabinetsApi = {
  list: (projectId: string) => api.get<ListCabinetsResponse>(`/projects/${projectId}/cabinets`),
  get: (projectId: string, id: string) =>
    api.get<CabinetDetails>(`/projects/${projectId}/cabinets/${id}`),
  create: (projectId: string, body: CreateCabinetRequest) =>
    api.post<CabinetDetails>(`/projects/${projectId}/cabinets`, body),
  createFromCatalog: (projectId: string, body: CreateCabinetFromCatalogRequest) =>
    api.post<CabinetDetails>(`/projects/${projectId}/cabinets/from-catalog`, body),
  update: (projectId: string, id: string, body: UpdateCabinetRequest) =>
    api.patch<CabinetDetails>(`/projects/${projectId}/cabinets/${id}`, body),
  remove: (projectId: string, id: string) =>
    api.delete<void>(`/projects/${projectId}/cabinets/${id}`),
};
